import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import IBox from '@meronex/icons/fi/FiBox';
import TopHeader from '../../../views/components/TopHeader';

import Product from '../../../factories/components/products/Product';

function StoreItemProductsDialog(props) {

  const { open, onClose, item, products } = props;

  return (
    <Dialog
      className={'fullScreenMobile'}
      open={open}
      scroll={'body'}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title">
      <DialogTitle>
        <TopHeader
          title={'Store Item Products'}
          onClose={onClose}
          icon={<IBox size={18} />}
        />
      </DialogTitle>
      <DialogContent>
        <div style={{ paddingBottom: '20px', fontSize: '18px' }}>
          {item.type.name} is used in {products.length} products:
        </div>
        <div style={{ display: 'block', height: window.innerHeight - 140 }}>
          <div
            style={{
              marginTop: '10px',
              maxHeight: '40px',
              minWidth: '300px',
            }}>
            {products.map((p) => (
              <div>
                <Product product={p} showFactory />
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

StoreItemProductsDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  products: PropTypes.array,
  item: PropTypes.object,
};

export default StoreItemProductsDialog;
